import {
  Chip,
  ChipProps,
  CircularProgress,
  IconButton,
  Stack,
  Theme,
  Typography,
  lighten,
  useTheme,
} from "@mui/material";
import { MdOutlineClose } from "react-icons/md";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

export function ModalTitleText(props: { children: React.ReactNode }) {
  // need to remove any built in html from children to prevent MUI typography from breaking
  const sanitizedChildren =
    typeof props.children === "string"
      ? props.children.replace(/<\/?[^>]+(>|$)/g, "")
      : props.children;
  return (
    <Typography variant="subtitle1" color="text.primary" fontWeight={600}>
      {sanitizedChildren}
    </Typography>
  );
}

export function ModalDescriptionText(props: { children: React.ReactNode }) {
  return (
    <Typography variant="body1" color="text.secondary">
      {props.children}
    </Typography>
  );
}

export function ModalCloseIcon(props: {
  onClick: (a: any) => void;
  disabled?: boolean;
}) {
  return (
    <IconButton
      disabled={props?.disabled}
      size="medium"
      onClick={props.onClick}
    >
      <MdOutlineClose />
    </IconButton>
  );
}

export function ModalBackIcon(props: {
  onClick: (a: any) => void;
  disabled?: boolean;
}) {
  return (
    <IconButton
      disabled={props?.disabled}
      size="medium"
      onClick={props.onClick}
    >
      <ArrowBackIosNewRoundedIcon fontSize="medium" />
    </IconButton>
  );
}

interface Props {
  onClick?: (e: any) => void;
  children?: React.ReactNode;
  variant?: ChipProps["color"];
  disabled?: boolean;
  isLoading?: boolean;
  size?: ChipProps["size"];
}

export function ModalActionButton(props: Props) {
  const theme = useTheme();
  const styles = useStyles(theme, props);

  const renderLabel = () => {
    if (!props.isLoading) return props.children;
    return (
      <Stack justifyContent={"center"}>
        <CircularProgress
          size={"14px"}
          sx={{
            color: props?.variant == "primary" ? "#ffffff" : "inherit",
          }}
        />
      </Stack>
    );
  };

  return (
    <Chip
      size={props?.size || "medium"}
      variant="filled"
      color={props?.variant == "primary" ? "primary" : "default"}
      label={renderLabel()}
      clickable
      onClick={props.onClick}
      sx={styles.modalActionButtonRoot}
      disabled={props.disabled}
    />
  );
}

function useStyles(theme: Theme, { variant }: Partial<Props>) {
  const primaryColor = theme.palette.primary.main;
  const secondaryColor = theme.palette.divider;
  return {
    modalActionButtonRoot: {
      width: "100%",
      cursor: "pointer",
      borderRadius: "6px",
      fontWeight: "600",
      // transition: "outline 0.2s ease-in-out",
      "&:hover": {
        // outline: `4px solid ${lighten(
        //   variant == "primary" ? primaryColor : secondaryColor,
        //   0.7
        // )}`,
      },
    },
  };
}
